<template>
  <el-row class='MarginCont'>
    <el-col :span="24">
      <div class="CodeCont hidden-xs-only">
        <el-col :span="24">
          <img class="QRCode"
               src="../assets/images/a.png"
               alt="">
        </el-col>
        <!-- <el-col :span="16"
                :offset="1">
		    <el-button type="danger"
		             @click="towarpath()">{{$t('QRCode.FindGame')}}</el-button>
          <p class="LoginTitle">{{$t('QRCode.follow')}}</p>
        </el-col> -->
      </div>
      <!-- 相关游戏 -->
      <correlationGame v-if="this.$route.query.gameId"></correlationGame>
      <div>
        <div class="RechargeCont">
          <!-- 快速充值 -->
          <div class="TitleFont">{{$t('QRCode.RecentRecharge')}}</div>
          <!-- <div class="Recharge">更多</div> -->
        </div>
        <div class="LoginBgCont"
             v-if="!this.$store.state.token">
          <!-- 登入/注册 -->
          <el-button type="danger"
                     @click="Loginshow = true">{{$t('QRCode.signreg')}}</el-button>
          <!-- 登入后可记录充值历史，方便快速充值 -->
          <p class="agre"
             @click="toArge">Đăng ký ngay</p>
          <!-- </router-link> -->
          <p class="LoginBtnTextCont">{{$t('QRCode.LoginBtnTextCont')}}</p>
        </div>
        <div class="LoginBgCont"
             v-if="this.$store.state.token&&this.$store.state.RecentRecharge.length==0">
          <!-- 您还没有充值历史,快去充值一笔吧 -->
          <div class="LoginUserInfo">
            {{$t('QRCode.LoginUserInfo')}}
          </div>
          <div class="LoginUserBalance"></div>
        </div>

        <swiper class="my-swiper-slide"
                v-if="showSwiper"
                ref="mySwiper"
                :options="swiperOption">
          <swiper-slide v-for="(item,index) in this.$store.state.RecentRecharge"
                        :key="index"
                        @click.native="ToRecharge(item)">
            <img :src="item.logoUrl"
                 class="swiper-lazy">
            <!-- <div class="swiper-lazy-preloader"></div> -->
            <div>
              <p v-if="item.gameList"
                 class="GameBriefTitle">{{item.gameList.gameName}}</p>
              <!-- <p class="GameBrief">{{item.gameAccountConext ? item.gameAccountConext.role_name : ''}}</p> -->

              <p class="GameBrief">{{item.roleName ? item.roleName : ''}}</p>
              <!-- <p class="GameBrief">{{item.gameAccountConext ? item.gameAccountConext.server_name : ''}}</p> -->
            </div>
          </swiper-slide>
          <div class="swiper-scrollbar"
               slot="scrollbar"></div>

        </swiper>

        <!-- <el-scrollbar v-if="this.$store.state.token&&this.$store.state.RecentRecharge.length>0"
                      wrap-class="default-scrollbar__wrap"
                      view-class="p20-scrollbar__view">
          <div class="IphoneGameCont">
            <div class="RechargeGame"
                 v-for="(item,ind) in this.$store.state.RecentRecharge"
                 :key='ind'
                 @click="ToRecharge(item)">
              <div class="RechargeGameTitle">
                <img :src="item.logoUrl">
                <div>
                  <p v-if="item.gameList"
                     class="GameBriefTitle">{{item.gameList.gameName}}</p>

                  <p class="GameBrief">{{item.gameRoleId ? item.gameRoleId : ''}}</p>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar> -->
      </div>
    </el-col>
    <login :Loginshow.sync="Loginshow"></login>
  </el-row>
</template>

<script>
//import GoogleSignInButton from 'vue-google-signin-button-directive'
// import jsonwebtoken from 'jsonwebtoken'
//import 'element-ui/lib/theme-chalk/display.css'
import login from '@/components/login'
import correlationGame from '@/components/module/correlationGame'

export default {
  name: 'QRCode',
  directives: {

  },
  components: {
    login,
    correlationGame
  },
  data () {
    return {
      showSwiper: false,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        scrollbar: {
          el: '.swiper-scrollbar',//滚动条
          draggable: true,
          hide: true,
        },
        mousewheel: true,//支持鼠标
        preventClicks: false,//允许click
        updateOnWindowResize: true,//默认当窗口(window) 尺寸发生变化时，比如屏幕旋转，Swiper会更新和重新计算(update和breakpoints等)
        on: {
          init: function () {
            this.scrollbar.updateSize();
          },
          resize: function () {
            //窗口变化了
            if (document.body.clientWidth < 768) {
              this.changeDirection('horizontal')
            } else {
              this.changeDirection('vertical')
            }
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 10,//slide之间设置距离（单位px）
        freeMode: true
        // ...
      },
      clientId: '657997517642-v6s8tnkf07p4k6qk0v4r8qg8p95qkt91.apps.googleusercontent.com', // Google AppId
      Loginshow: false,
      AllUserInfo: '',
      token: '',
      RechargeShow: false,
      RecentRecharge: [] // 最近充值游戏列表
    }
  },
  watch: {
    '$store.state.count' () {
      this.UserInfoLogin()
      if (this.token) {
        this.LastGame()
      } this.RechargeShow = true
    }
  },
  created () {
    this.UserInfoLogin()
    if (this.token) {
      this.LastGame()
    } this.RechargeShow = true
  },
  methods: {
    OnGoogleAuthSuccess (idToken) { // Google登入返回token
      this.GgLogin(idToken)
    },
    OnGoogleAuthFail (error) { // Google 取消或报错
      console.log(error)
    },
    GgLogin (token) {
      this.$axios.post(this.apiUrl.API.GgLogin, {
        idToken: token,
        terminalType: 'APP_GAME_SHOP'
      })
        .then((res) => {
          if (res.data.resCode == 'C502570000000') {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
            sessionStorage.setItem('userToken', res.data.userToken)
            this.$store.state.count = res.data.userInfo
          }
        })
    },
    UserInfoLogin () {
      if (this.$store.state.count) {
        if (typeof (this.$store.state.count) == 'string') {
          this.AllUserInfo = JSON.parse(this.$store.state.count)
        } else {
          this.AllUserInfo = this.$store.state.count
        }
      } else {
        this.AllUserInfo = ''
      }
      this.token = this.$store.state.token
    },
    // 查询最近充值游戏
    LastGame () {
      // console.log(this.$store.state.token)
      let data = {
        params: {
          userToken: this.$store.state.token
        }
      }
      this.$axios.get(this.apiUrl.API.LastGame, data)
        .then((res) => {

          if (res.data.data.length > 0) {
            this.RecentRecharge = res.data.data
            for (let i = 0; i < this.RecentRecharge.length; i++) {
              this.RecentRecharge[i].gameAccountConext = JSON.parse(this.RecentRecharge[i].gameAccountConext)
            }
            this.$store.commit('RecentRechargeList', this.RecentRecharge);
            if (document.body.clientWidth < 768) {
              this.swiperOption.direction = 'horizontal'
            } else {
              this.swiperOption.direction = 'vertical'
            }
            this.showSwiper = true
          } else {
            this.RecentRecharge = []
            this.$store.commit('RecentRechargeList', this.RecentRecharge);
            this.showSwiper = false
          }

        })
    },
    // 判断快速充值对应的url
    ToRecharge (item) {
      if (this.$store.state.token) {
        window.open(item.quickDepositUrl + '&userToken=' + this.$store.state.token)
      } else {
        window.open(item.quickDepositUrl)
      }

      // let url;
      // if (item.gameNo == 'BBG_D') { // 三国快速充值
      //   url = `https://ttq.pay.100d.mobi/rechargeSelect?userName=${item.gameAccountConext.roleId}&server=${item.gameServerId}`
      // }
      // if (item.gameNo == 'YOUZU_D') { // 游族-神都夜行录-快速充值
      //   url = `https://ptd.choigame.xyz/rechargeSelect?userName=${item.gameAccountConext.account}&server=${item.gameAccountConext.server_id}&roleId=${item.gameAccountConext.role_id}`
      // }
      // if (item.gameNo == 'SAI_ER_Z_G_D') { // 游族-赛尔之光-快速充值
      //   url = `https://lotsezg.gtarcade.com/rechargeSelect?userName=${item.gameAccountConext.account}&server=${item.gameAccountConext.server_id}&roleId=${item.gameAccountConext.role_id}`
      // }
      // if (item.gameNo == 'LIE_WANG_D') { // cok-列王-快速充值
      //   url = `https://cok.pay.100d.mobi/rechargeSelect?userName=${item.gameAccountConext.roleId}`
      // }
      // if (item.gameNo == '1567996030589280') { // 4399-yongHeroes快速充值
      //   url = `https://yong.pay.100d.mobi/rechargeSelect?userName=${item.gameAccountId}&server=${item.gameServerId}&roleId=${item.gameRoleId}`
      // }
      // window.location.href = url
    },
    toArge () { // 跳转到协议
      this.$router.push({
        path: `/dieu-khoan`
      })
    },
	towarpath(){
		window.open("./ArticleDetails?id=13cda76b46d54954bb0951612f3fad94&Cla=Banner")
		 // window.location.href = 
	}
  }
}
</script>

<style scoped>
.el-scrollbar__wrap--hidden-default {
  width: 100%;
}
.LoginUserInfo {
  font-size: 16px;
}
.LoginUserBold {
  font-size: 14px;
  font-weight: bold;
}
.LoginUserBalance {
  font-size: 16px;
  text-align: left;
  padding: 0 1rem;
  margin-top: 1rem;
}
.CodeCont {
  text-align: center ;
  border-radius: 3px;
  padding:15px 25px 10px 10px;
  background: #fff;
  display: flex;
  align-items: center;
  margin: 3rem 0 0 0;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}
.QRCode {
  width: 7rem;
}
.FindGame {
  font-size: 1.333rem;
  font-weight: bold;
  color: #14b9c8;
  margin: 0 0 12px 0;
}
.LoginTitle {
	text-align: center;
  margin-top: 10px;
  color: #999;
  /* line-height: 3.63rem; */
}
/* .LoginCont {
  height: 3rem;
} */
/* .LoginCont img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
} */
.RechargeCont {
  display: flex;
  justify-content: space-between;
}
.TitleFont {
  color: #333;
  font-size: 1.333rem;
  border-left: 0.5rem solid #ff7473;
  padding-left: 0.4rem;
  margin: 1.333rem 0 1rem 0;
}
.Recharge {
  margin-top: 1.7rem;
  color: #14b9c8;
  padding-right: 4.167rem;
}
.my-swiper-slide {
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}
.swiper-slide {
  cursor: pointer;
  width: auto; /*根据内容调整宽度*/
  border-radius: 3px;
  background: #fff;
  display: flex;
  padding: 10px;
  /* margin: 0 0 10px 0; */
  /* box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2); */
}

.swiper-wrapper img {
  width: 5.167rem;
  height: 5.167rem;
  border-radius: 1rem;
  margin: 0 0.6rem 0 0;
  border: none !important;
}
.swiper-scrollbar {
  bottom: 0;
}
/* .IphoneGameCont {
  background: #fff;
  padding: 0 15px 15px 15px;
} */
/* .RechargeGame {
  width: calc(100% - 1rem);
  margin: 0 auto;
  padding-top: 1.417rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  background: #fff;
  cursor: pointer;
}
.RechargeGameTitle {
  display: flex;
}
.RechargeGameTitle > img {
  height: 5.167rem;
  width: 5.167rem;
  border-radius: 1rem;
  margin-right: 0.833rem;
} */
/* .RechargeGameGo {
  font-size: 2.833rem;
  padding-top: 0.5rem;
  color: #999;
  padding-right: 3.167rem;
} */
.GameBriefTitle {
  font-size: 14px;
}
.GameBrief {
  color: #999;
  line-height: 1.667rem;
}
.LoginBgCont {
  border-radius: 3px;
  text-align: center;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  /* box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2); */
  padding: 25px;
  background: #fff;
}
.el-button {
  width: 100%;
  text-align: center;
  padding: 14px 0;
}
.agre {
  margin-top: 10px;
  cursor: pointer;
  color: #f56c6c;
}
.LoginBtnTextCont {
  margin-top: 10px;
}
@media (max-width: 1200px) {
  .FindGame {
    font-size: 1.166rem;
  }
  .LoginCont img {
    height: 2.3rem;
    width: 2.3rem;
  }
  .LoginTitle {
    /* line-height: 4rem; */
  }
  /* .RechargeGameGo {
    padding-right: 2.5rem;
  } */
}
@media (max-width: 991px) {
  .FindGame {
    font-size: 12px;
  }
  .QRCode {
    width: 6rem;
    height: 6rem;
    margin: 0.667rem 0;
  }
  .LoginCont img {
    height: 1.7rem;
    width: 1.7rem;
  }
  .LoginTitle {
    /* line-height: 3rem; */
  }
  .MarginCont {
    padding-left: 20px;
  }
  /* .RechargeGameGo {
    padding-right: 0;
  } */
  /* .RechargeGameTitle > img {
    width: 4.5rem;
    height: 4.5rem;
    margin-right: 0.6rem;
  } */
  .GameBriefTitle {
    font-size: 12px;
  }
  /* .RechargeGameGo {
    font-size: 20px;
    padding-top: 1rem;
  } */
  .Recharge {
    padding-right: 1rem;
  }
}
@media (max-width: 767px) {
  .MarginCont {
    padding: 0;
  }
  /* .IphoneGameCont {
    display: -webkit-box;
    background: #f2f2f2;
  } */
  /* .RechargeGameTitle {
    display: -webkit-box;
  }
  .RechargeGame {
    width: auto;
    margin: 10px 4px;
    padding-top: 0;
    padding: 10px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
    margin-right: 10px;
  } */
  /* .RechargeGameGo {
    margin-left: 10px;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/QRCode.vue